/**
 * Feature flags for optional modules during development.
 *
 * REACT_APP_SUBSCRIPTION_ENFORCEMENT mirrors backend SUBSCRIPTION_ENFORCEMENT.
 * When unset in development builds, subscription gates are off.
 */
export function isSubscriptionEnforcementEnabled() {
    const raw = process.env.REACT_APP_SUBSCRIPTION_ENFORCEMENT;
    if (raw != null && String(raw).trim() !== '') {
        const val = String(raw).trim().toLowerCase();
        if (['false', '0', 'off', 'no', 'disabled'].includes(val)) return false;
        if (['true', '1', 'on', 'yes', 'enabled'].includes(val)) return true;
    }
    return process.env.NODE_ENV === 'production';
}

/**
 * Manufacturing module (sidebar + /mfg routes).
 * Flip to true when ready to expose Manufacturing in the UI again.
 */
export const SHOW_MANUFACTURING_UI = false;
